import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TuiProgressModule } from "@taiga-ui/kit";
import { KwikUIProgressCircleComponent } from "./progress-circle.component";

@NgModule({
  declarations: [KwikUIProgressCircleComponent],
  imports: [CommonModule, TuiProgressModule],
  exports: [KwikUIProgressCircleComponent]
})
export class KwikUIProgressCircleModule {}
